export const errorHandler = (error: unknown, defaultMessage: string)  => {
  if (error instanceof Error) {
    throw new Error(error.message);
  }

  if (typeof error === 'string') {
    throw new Error(error);
  }

  throw new Error(defaultMessage);
};
